/**
 * Herontwerp P7 — the instructor variant's client-safe vocabulary (the
 * roster-fields.ts idiom): the arrival lead, the time chips, the moods and
 * "wat werkte" tags of the note tray, and the two pure time helpers. The
 * trays import from here; stal-instructeur.server.ts re-uses it.
 */

/** Design: E. gets her arrival time 45–75 min before the lesson. */
export const ARRIVAL_LEAD_MIN = 45
export const LESSON_TIMES = [
	'09:30',
	'10:00',
	'10:30',
	'11:00',
	'12:00',
	'14:00',
	'15:00',
]
export const MOODS = ['😊', '🙂', '😐', '😕'] as const
export const NOTE_TAGS = [
	'op tijd',
	'foto na de les',
	'rustig begin',
	'rechts afstappen',
] as const

const TIME_RE = /^([01]?\d|2[0-3]):([0-5]\d)$/

export function shiftTime(hhmm: string, minutes: number): string {
	const m = TIME_RE.exec(hhmm)
	if (!m) return hhmm
	const total = Math.min(
		23 * 60 + 59,
		Math.max(0, Number(m[1]) * 60 + Number(m[2]) + minutes),
	)
	return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`
}

export function minutesOf(hhmm: string): number {
	const m = TIME_RE.exec(hhmm)
	return m ? Number(m[1]) * 60 + Number(m[2]) : 0
}

export function arrivalFor(time: string): string {
	return shiftTime(time, -ARRIVAL_LEAD_MIN)
}

const MOOD_RE = /^(\p{Extended_Pictographic}(?:️)?)\s+/u

/** A stored note "😊 zin" → its mood and sentence. */
export function splitNote(noteNl: string): { mood: string; text: string } {
	const m = MOOD_RE.exec(noteNl)
	return m
		? { mood: m[1]!, text: noteNl.slice(m[0].length) }
		: { mood: '', text: noteNl }
}
